// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"vz_a bhc_b","TwoDimsListFeature__item":"vz_b bhc_ux","TwoDimsListFeature__item__text":"vz_c bhc_un"};